export const PHONE_PLAN_RENTALS_CARD = 'PHONE_PLAN_RENTALS_CARD'
